module.exports = __webpack_public_path__ + "static/media/bruxellex-placuta.c5bdbf69.png";